export default {
  ACCOUNT_OVERVIEW_PAGE: '/',
  HOME: '/home-services',
  ORDERS: '/orders',
  TRACK_ORDER: '/orders/:id/track',
  CANCEL_ORDER: '/orders/:id/cancel',
  CANCEL_ORDER_REASON: '/reason',
  CANCEL_ORDER_CONFIRM: '/confirmation',
  CANCEL_ITEMS: '/orders/:id/cancel-items',
  CANCEL_ITEMS_SELECT: '/select',
  CANCEL_ITEMS_REVIEW: '/review',
  CANCEL_ITEMS_CONFIRM: '/confirmation',
  RETURN_ITEMS: '/orders/:id/return-items',
  RETURN_ITEMS_METHOD: '/method',
  RETURN_ITEMS_INFORMATION: '/information',
  RETURN_ITEMS_JL: '/via-jl-store',
  RETURN_ITEMS_SELECT: '/select',
  RETURN_ITEMS_UNSUPPORTED_REASON: '/unsupported-reason',
  RETURN_ITEMS_SUMMARY: '/review',
  RETURN_ITEMS_CONFIRM: '/confirmation',
  TRACK_ORDER_FORM: '/track-order',
  VIEW_ORDER: '/orders/:id',
  VAT_RECEIPTS: '/orders/:orderid/receipts/:receiptid',
  MY_DETAILS: '/my-details',
  PAYMENT_CARDS: '/my-details/payment-cards',
  PAYMENT_CARDS_ADD: '/my-details/payment-cards/add',
  ADDRESS_BOOK: '/my-details/address-book',
  ADDRESS_BOOK_ADD: '/my-details/address-book/add',
  ADDRESS_BOOK_EDIT: '/my-details/address-book/:addressId',
  CONTACT_DETAILS: '/my-details/contact',
  WISH_LIST_HOME: '/wish-list',
  VIEW_WISH_LIST: '/wish-list/:id',
  MARKETING_PREFERENCES: '/marketing-preferences',
  UPDATE_MARKETING_PREFERENCES: '/marketing-preferences/update',
  MY_JL: '/my-jl',
  STORE_RECEIPTS: '/store-receipts',
  VIEW_STORE_RECEIPTS: '/store-receipts/transaction/:transactionid',
  MY_JL_REGISTER: '/my-jl/register',
  MY_JL_DETAILS: '/my-jl/details',
  REVIEWS: '/reviews',
  APPOINTMENTS: '/appointments',
  HELP: '/need-help', // TODO -> /help after global redirect is removed
  LOGIN: '/login',
  REPERMISSION: '/repermission',
  REGISTER: '/register',
  ACCOUNT_CREATED: '/account-created',
  ACCOUNT_CREATED_MY_JL: '/account-created-my-jl',
  SIGN_OUT: '/sign-out',
  ONE_REDIRECT: '/redirect/:platform/:to',
  LEGACY_TRACK_ORDER_FORM: '/track-your-order',
  EDIT_PASSWORD: '/my-details/edit-password',
  AUTH0_CALLBACK: '/auth0/callback/:initialScreen',
  REWARDS_AND_TREATS: '/rewards',
  REWARD_AND_TREAT: '/rewards/:voucherId',
};
